
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("3htI3", function(module, exports) {

$parcel$export(module.exports, "setTheme", () => $263a0159e11bb783$export$2e49b867b7a0847c);

var $2dZEa = parcelRequire("2dZEa");

var $6JDwD = parcelRequire("6JDwD");

var $9LUdH = parcelRequire("9LUdH");

var $44W0X = parcelRequire("44W0X");
const $263a0159e11bb783$var$lightbulbOn = `<svg xmlns="http://www.w3.org/2000/svg" 
viewBox="0 0 24 24" fill="none" 
stroke="currentColor" 
stroke-width="2" 
stroke-linecap="round" 
stroke-linejoin="round" 
class="lucide lucide-lightbulb-icon lucide-lightbulb">
<path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/>
<path d="M9 18h6"/><path d="M10 22h4"/></svg>`;
const $263a0159e11bb783$var$lightbulbOff = `<svg xmlns="http://www.w3.org/2000/svg" 
width="24" height="24" viewBox="0 0 24 24" fill="none"
stroke="currentColor" stroke-width="2" 
stroke-linecap="round" 
stroke-linejoin="round" 
class="lucide lucide-lightbulb-off-icon lucide-lightbulb-off">
<path d="M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5"/>
<path d="m2 2 20 20"/><path d="M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5"/>
<path d="M9 18h6"/><path d="M10 22h4"/></svg>`;
const $263a0159e11bb783$var$button = document.getElementById("theme-toggle");
const $263a0159e11bb783$var$logo = document.getElementById("logo");
console.log("Theme JS loaded");
console.log("Button:", $263a0159e11bb783$var$button);
console.log("Logo:", $263a0159e11bb783$var$logo);
function $263a0159e11bb783$export$2e49b867b7a0847c(isDark) {
    document.body.classList.toggle("light-theme", isDark);
    const pitch = document.getElementById("pitch");
    if (isDark) {
        $263a0159e11bb783$var$logo.src = (0, (/*@__PURE__*/$parcel$interopDefault($6JDwD)));
        if (pitch) {
            pitch.setAttribute("href", (0, (/*@__PURE__*/$parcel$interopDefault($44W0X))));
            pitch.setAttribute("xlink:href", (0, (/*@__PURE__*/$parcel$interopDefault($44W0X))));
        }
        $263a0159e11bb783$var$button.innerHTML = $263a0159e11bb783$var$lightbulbOn;
        localStorage.setItem("theme", "light");
    } else {
        $263a0159e11bb783$var$logo.src = (0, (/*@__PURE__*/$parcel$interopDefault($2dZEa)));
        if (pitch) {
            pitch.setAttribute("href", (0, (/*@__PURE__*/$parcel$interopDefault($9LUdH))));
            pitch.setAttribute("xlink:href", (0, (/*@__PURE__*/$parcel$interopDefault($9LUdH))));
        }
        $263a0159e11bb783$var$button.innerHTML = $263a0159e11bb783$var$lightbulbOff;
        localStorage.setItem("theme", "dark");
    }
}
$263a0159e11bb783$var$button.addEventListener("click", ()=>{
    const isDark = !document.body.classList.contains("light-theme");
    // Asks is the page dark? or more specifically, does it NOT contain light-theme?
    $263a0159e11bb783$export$2e49b867b7a0847c(isDark);
});
const $263a0159e11bb783$var$savedTheme = localStorage.getItem("theme");
$263a0159e11bb783$export$2e49b867b7a0847c($263a0159e11bb783$var$savedTheme === "light");
document.body.classList.add("theme-ready"); // Notes
 // When we click the button, setTheme(isDark) is run. 
 // document.body.classList.toggle("light-theme", isDark) then says toggle light-theme depending on the answer of isDark
 // If isDark is true (i.e. the page is currently dark), light-theme is applied.
 // If isDark is false (i.e. the page is currently light), light-theme is removed.

});
parcelRegister("2dZEa", function(module, exports) {
module.exports = new URL("emblem-colors.eb71e978.png", import.meta.url).toString();

});

parcelRegister("6JDwD", function(module, exports) {
module.exports = new URL("emblem-colors-light.5d3d59b0.png", import.meta.url).toString();

});

parcelRegister("9LUdH", function(module, exports) {
module.exports = new URL("pitch.c39add89.jpg", import.meta.url).toString();

});

parcelRegister("44W0X", function(module, exports) {
module.exports = new URL("pitch_light.0ce1d5f1.jpg", import.meta.url).toString();

});


var $fbc43b12c275827e$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["aEt5T","index.ab8d4630.js","eLIbB","emblem-colors.eb71e978.png","bM0Ta","emblem-colors-light.5d3d59b0.png","9hHJp","pitch.c39add89.jpg","4wRTy","pitch_light.0ce1d5f1.jpg"]'));


parcelRequire("3htI3");

//# sourceMappingURL=index.ab8d4630.js.map
